import { Logout } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useContext, useEffect, useState } from 'react';
import RootContext from '../../../util/root.context';
import { getCookie } from '../../hooks/useCookie';
// import { getCookie } from '../../hooks/useCookie';
import { useToggle } from '../../hooks/useToggle';
import EirLogOutModal from './EirLogOutModal';
// import styles from './style';

/**
 * @param {string} ctaText - ctaText is string parameter.
 */

const EirLogOut = ({ ctaText, cmsData }) => {
  const theme = useTheme();
  const { state } = useContext(RootContext);
  const confirmLogOut = useToggle(false);
  const [customerName, setCustomerName] = useState(getCookie('customer_Name') || '');

  const getConfimationModal = () => {
    confirmLogOut.enable();
  };

  useEffect(() => {
    const loggedInCustomer = getCookie('customer_Name');
    if (loggedInCustomer) {
      setCustomerName(loggedInCustomer);
    }
  }, [customerName, getCookie('customer_Name')]);

  return state?.enableLogout ? (
    <>
      <Box
        sx={{
          pl: '24px',
          display: 'flex',
          textDecoration: 'none',
          alignItems: 'center',
          '&:hover': {
            textDecoration: 'underline',
            cursor: 'pointer',
          },
        }}
        onClick={getConfimationModal}
      >
        <Logout sx={{ color: theme.palette.primary.buttonColor, fontSize: '1.3rem' }} />
        <Typography variant='body2' sx={{ pl: '0.5rem' }}>
          {ctaText} {customerName}
        </Typography>
      </Box>
      <EirLogOutModal confirmLogOut={confirmLogOut} cmsData={cmsData} />
    </>
  ) : (
    ''
  );
};

export default EirLogOut;
